<template lang="pug">

.vc-product-quantity-picker(:class="{ disabled: isConfirmed }")
  .label {{ actionLocaleText('set_quantity') }}

  .picker-unit
    .option-button.minus(@click="onClick($event, decreaseQuantity)"
                         @mousedown="onStartLongPress($event, decreaseQuantity)"
                         @touchstart.prevent="onStartLongPress($event, decreaseQuantity)"
                         @mouseup="onStopLongPress($event, decreaseQuantity)"
                         @mouseleave="onStopLongPress($event, decreaseQuantity)"
                         @touchend="onStopLongPress($event, decreaseQuantity)"
                         @touchcancel="onStopLongPress($event, decreaseQuantity)")
      .icon
        i.fa.fa-minus
    .quantity-display
      span.number {{ quantity }}
    .option-button.plus(@click="onClick($event, increaseQuantity)"
                        @mousedown="onStartLongPress($event, increaseQuantity)"
                        @touchstart.prevent="onStartLongPress($event, increaseQuantity)"
                        @mouseup="onStopLongPress($event, increaseQuantity)"
                        @mouseleave="onStopLongPress($event, increaseQuantity)"
                        @touchend="onStopLongPress($event, increaseQuantity)"
                        @touchcancel="onStopLongPress($event, increaseQuantity)")
      .icon
        i.fa.fa-plus

</template>

<script>
export default {
  // components: {},
  // mixins: [],
  props: {
    quantity: {
      type: Number,
      required: true,
    },

    isCheckingStock: {
      type: Boolean,
      required: false,
      default: () => {
        return true
      },
    },

    currentStock: {
      type: Number,
      required: true,
    },

    isConfirmed: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      },
    },

    // 長押多久開始連續攻擊，預設半秒
    longPressThrottle: {
      type: Number,
      required: false,
      default: () => {
        return 500
      },
    },
  },

  // data() {
  //   return {}
  // },

  computed: {
    isQuantityMeetCounterStop() {
      return this.quantity >= this.currentStock && this.isCheckingStock
    },
  },
  // created() {},
  // mounted() {},
  methods: {
    onClick(event, callback) {
      if (event.detail !== 0 || event.type === 'click') return

      callback()
    },

    onStartLongPress(event, callback) {
      if (event.button !== 0 && event.type !== 'touchstart') return

      this._$intervalTime = new Date()
      this._clearInterval()
      this._$timerRef = setTimeout(() => {
        this._$intervalRef = setInterval(() => {
          callback()
        }, 88)
      }, this.longPressThrottle)
    },

    onStopLongPress(event, callback) {
      if (!this._$timerRef) return

      if (!this._$intervalRef) callback()
      this._clearInterval()
      this._clearTimer()
    },

    _clearTimer() {
      clearTimeout(this._$timerRef)
      this._$timerRef = null
    },

    _clearInterval() {
      clearInterval(this._$intervalRef)
      this._$intervalRef = null
    },

    increaseQuantity() {
      if (this.isConfirmed) return
      if (this.isQuantityMeetCounterStop && this.isCheckingStock) return

      this.$emit('update:quantity', this.quantity + 1)
    },

    decreaseQuantity() {
      if (this.isConfirmed) return
      if (this.quantity === 1) return

      this.$emit('update:quantity', this.quantity - 1)
    },
  },
}
</script>
